import { render } from "./assessObjApproval.vue?vue&type=template&id=676c7cce&scoped=true"
import script from "./assessObjApproval.vue?vue&type=script&lang=js"
export * from "./assessObjApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676c7cce"]])

export default __exports__